/* يكتشف الأجهزة الضعيفة ويضيف class "perf-lite" على <html> (يطفّي حركة الخلفية والـ blur). */
const KEY = "sh_perf";

function apply(lite: boolean) {
  document.documentElement.classList.toggle("perf-lite", lite);
}

function weakByHardware(): boolean {
  const n = navigator as Navigator & { deviceMemory?: number; connection?: { saveData?: boolean } };
  if (n.connection?.saveData) return true;
  if (typeof n.deviceMemory === "number" && n.deviceMemory <= 3) return true;
  if (typeof n.hardwareConcurrency === "number" && n.hardwareConcurrency <= 4) return true;
  return false;
}

export function installPerfMode() {
  let stored: string | null = null;
  try {
    stored = localStorage.getItem(KEY);
  } catch {
    /* ignore */
  }
  if (stored === "lite" || weakByHardware()) apply(true);
  if (stored === "lite" || stored === "full") return;

  // قياس فعلي: بعد ما يستقر التحميل نقيس FPS لثانيتين. تحت 40 = جهاز ضعيف، ونتذكرها.
  const run = () => {
    let frames = 0;
    const t0 = performance.now();
    const tick = (t: number) => {
      frames++;
      if (t - t0 < 2000) return void requestAnimationFrame(tick);
      const fps = (frames * 1000) / (t - t0);
      const lite = fps < 40;
      if (lite) apply(true);
      try {
        localStorage.setItem(KEY, lite ? "lite" : "full");
      } catch {
        /* ignore */
      }
    };
    requestAnimationFrame(tick);
  };
  window.addEventListener("load", () => window.setTimeout(run, 4500), { once: true });
}
